import { combineReducers } from "redux";
import itemReducer from "./reducer";

const reducer = combineReducers({
  itemReducer,
});

export default reducer;
